import type { ISocialOffer } from "@bbj-types/offer";
import { type ReactNode, createContext, useCallback, useContext, useState } from "react";
import { type IModalSocialOfferProps, ModalSocialOffer } from "./index";

export type TOpenModalSocialOffer = (
  socialOffer: IModalSocialOfferProps["socialOffer"],
  updateCallback?: IModalSocialOfferProps["onUpdate"],
  duplicate?: boolean,
  provider?: ISocialOffer["provider"]
) => void;

const Context = createContext<TOpenModalSocialOffer>(() => undefined);

export const useModalSocialOfferContext = () => useContext(Context);

export interface IModalSocialOfferProviderProps {
  children: ReactNode;
}

export const ModalSocialOfferProvider = ({ children }: IModalSocialOfferProviderProps) => {
  const [open, setOpen] = useState(false);
  const [offer, setOffer] = useState<IModalSocialOfferProps["socialOffer"]>(null);
  const [updateCallback, setUpdateCallback] = useState<IModalSocialOfferProps["onUpdate"]>();
  const [isDuplication, setIsDuplication] = useState<boolean>(false);
  const [defaultProvider, setDefaultProvider] = useState<IModalSocialOfferProps["defaultProvider"] | undefined>(
    undefined
  );

  const handleClose = () => {
    setOpen(false);
  };

  const openModalSocialOffer: TOpenModalSocialOffer = useCallback(
    (socialOffer, updateCallback, duplicate = false, defaultProvider = undefined) => {
      setOpen(true);
      setOffer(socialOffer);
      setIsDuplication(duplicate);
      setUpdateCallback(() => updateCallback);
      setDefaultProvider(defaultProvider);
    },
    []
  );

  return (
    <Context.Provider value={openModalSocialOffer}>
      {children}
      <ModalSocialOffer
        open={open}
        socialOffer={offer}
        onClose={handleClose}
        isDuplication={isDuplication}
        onUpdate={updateCallback}
        defaultProvider={defaultProvider}
      />
    </Context.Provider>
  );
};
